'use client'
import { __awaiter } from '../../_virtual/_tslib.js';
import nacl from 'tweetnacl';
import bs58 from 'bs58';

const buildUrl = (path, params) => `https://phantom.app/ul/v1/${path}?${params.toString()}`;
const decryptPayload = (data, nonce, sharedSecret) => {
    const decryptedData = nacl.box.open.after(bs58.decode(data), bs58.decode(nonce), sharedSecret);
    if (!decryptedData) {
        throw new Error('Unable to decrypt data');
    }
    return JSON.parse(Buffer.from(decryptedData).toString('utf8'));
};
const encryptPayload = (payload, sharedSecret) => {
    const nonce = nacl.randomBytes(24);
    const encryptedPayload = nacl.box.after(Buffer.from(JSON.stringify(payload)), nonce, sharedSecret);
    return [nonce, encryptedPayload];
};
const GENESIS_HASHES = {
    '4uhcVJyU9pJkvQyS88uRDiswHXSCkY3zQawwpjk2NsNY': 'testnet',
    '5eykt4UsFv8P8NJdTREpY1vzqKqZKvdpKuc147dw2N9d': 'mainnet-beta',
    EtWTRABZaYq6iMfeYKouRu166VU2xqa1wcaWoxPkrZBG: 'devnet',
};
const fetchCluster = (rpc) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { result } = yield (yield fetch(rpc, {
            body: JSON.stringify({
                id: 1,
                jsonrpc: '2.0',
                method: 'getGenesisHash',
            }),
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'POST',
        })).json();
        return GENESIS_HASHES[result];
    }
    catch (err) {
        return 'mainnet-beta';
    }
});

export { buildUrl, decryptPayload, encryptPayload, fetchCluster };
